export const Z_INDEX_VALUES = {
  low: 1000,
  medium: 1001,
  high: 1002,
};
